export const TAX_SERVICES = 'taxservices';
export const MONEY_PRO = 'money';
export const INVOICES = 'invoices';
export const BANKING = 'banking';
export const FINANCE_HUB = 'financehub';
